"use client";
import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { ChevronDown, ChevronUp } from "lucide-react";

const Footer = () => {
  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  // Contact and social data
  const contactInfo = [
    {
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
        </svg>
      ),
      label: "Call Us",
      text: "+91 74706 75398",
    },
    {
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
          <polyline points="22,6 12,13 2,6"></polyline>
        </svg>
      ),
      label: "Email Us",
      text: "harshhasthkala@gmail.com",
    },
    {
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </svg>
      ),
      label: "Find Us",
      text: "1137, Sanjeevani Nagar, Jabalpur M.P. - 482003",
      isLink: true,
      url: "https://maps.app.goo.gl/yYQFekezn9Dgi8k78",
    },
  ];

  const socialLinks = [
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/company/harsh-hasthkala/",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
        </svg>
      ),
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/harshhasthkala/?hl=en",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
        </svg>
      ),
    },
    {
      name: "Pinterest",
      url: "https://in.pinterest.com/hhkgifts/",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 0c-6.627 0-12 5.373-12 12 0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146 1.124.347 2.317.535 3.554.535 6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z" />
        </svg>
      ),
    },
    {
      name: "Location",
      url: "https://maps.app.goo.gl/yYQFekezn9Dgi8k78",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
        </svg>
      ),
    },
  ];

  const quickLinks = [
    { name: "Our Products", path: "/shop" },
    { name: "Track Order", path: "/track-order" },
    { name: "About Us", path: "/about-us" },
    { name: "Contact Us", path: "/contact-us" },
    { name: "Gift Hampers", path: "/hamper/?id=D3jUco5CHGcrWadlRPLv" },
    { name: "Blog", path: "/blog" },
  ];

  const infoLinks = [
    { name: "Cancellation & Refund", path: "/cancellation-&-refund-policy" },
    { name: "Payment Policy", path: "/payment-policy" },
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "FAQ", path: "/faq" },
    { name: "Shipping Policy", path: "/shipping-policy" },
    { name: "Terms & Conditions", path: "/terms-&-conditions" },
  ];

  // Reusable section component
  const FooterSection = ({ title, links, isActive, onToggle }) => (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-bold text-xl relative inline-block">
          {title}
          <div className="h-1 w-12 bg-white mt-1 hidden md:block"></div>
        </h2>
        <button
          className="md:hidden p-1"
          onClick={onToggle}
          aria-label={isActive ? `Hide ${title}` : `Show ${title}`}
        >
          {isActive ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </button>
      </div>
      <div
        className={`transition-all duration-300 ease-in-out overflow-hidden ${
          isActive ? "max-h-96" : "max-h-0"
        } md:max-h-96`}
      >
        <ul className="space-y-3">
          {links.map((link, index) => (
            <li key={index}>
              <Link
                href={link.path}
                className="group flex items-center text-white hover:text-white transition-all duration-300 relative py-1"
              >
                <span className="absolute left-0 bottom-0 h-0.5 bg-white w-0 group-hover:w-full transition-all duration-300"></span>
                <span className="relative">{link.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );

  return (
    <footer className="text-white relative w-full overflow-hidden">
      {/* Top Wave SVG - Fixed to prevent overflow */}
      <div className="relative w-full overflow-hidden">
        <svg
          className="w-full h-16 md:h-20"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
            fill="#FFEEEE"
            opacity="0.25"
          ></path>
        </svg>
      </div>

      {/* Main Footer - Fixed container width */}
      <div className="bg-gradient-to-b from-[#bd1818] to-[#8B0000] pt-12 pb-6 relative w-full">
        {/* Decorative geometric elements - Constrained to the container */}
        <div className="absolute inset-0 overflow-hidden opacity-10 pointer-events-none">
          <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-white transform translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-white transform -translate-x-1/2 translate-y-1/4"></div>
        </div>

        <div className="container mx-auto max-w-6xl px-4 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8">
            {/* Logo and Contact Section */}
            <div className="lg:col-span-4 flex flex-col items-center md:items-start">
              <Link
                href="/"
                className="mb-6 transform hover:scale-105 transition-transform"
              >
                <Image
                  src="/logo-R.png"
                  alt="Hasthkala Logo"
                  width={100}
                  height={100}
                  className="w-24 h-24"
                  priority
                />
              </Link>

              <div className="my-4 text-sm flex flex-col space-y-4">
                {contactInfo.map((item, index) => (
                  <div key={index} className="flex items-start">
                    <div className="p-2 bg-white text-[#bd1818] rounded-full mr-3 flex-shrink-0">
                      {item.icon}
                    </div>
                    <div className="flex-1 break-words">
                      <p className="font-semibold text-sm">{item.label}</p>
                      {item.isLink ? (
                        <a
                          href={item.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-gray-200 hover:text-white"
                        >
                          {item.text}
                        </a>
                      ) : (
                        <p className="text-gray-200">{item.text}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div className="lg:col-span-2">
              <FooterSection
                title="Quick Links"
                links={quickLinks}
                isActive={activeSection === "quick"}
                onToggle={() => toggleSection("quick")}
              />
            </div>

            {/* More Info */}
            <div className="lg:col-span-3">
              <FooterSection
                title="More Info"
                links={infoLinks}
                isActive={activeSection === "info"}
                onToggle={() => toggleSection("info")}
              />
            </div>

            {/* Subscribe Section */}
            <div className="lg:col-span-3">
              <h2 className="font-bold text-xl mb-4 relative inline-block">
                Join Us Now
                <div className="h-1 w-12 bg-white mt-1 hidden md:block"></div>
              </h2>
              <p className="mb-4 text-gray-200">
                Stay updated with our latest products and special offers!
              </p>

              <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
                <div className="relative overflow-hidden rounded-lg">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    aria-label="Email subscription"
                    className="w-full px-4 py-3 bg-white bg-opacity-10 focus:outline-none transition-all duration-300 border-2 border-transparent focus:border-white"
                  />
                </div>
                <button
                  type="submit"
                  className="inline-block w-full bg-white text-[#bd1818] font-bold py-3 px-6 rounded-lg hover:bg-[#FFEEEE] transition-all duration-300 relative overflow-hidden"
                >
                  <span className="relative z-10">Subscribe</span>
                </button>
              </form>
            </div>
          </div>

          {/* Social Media Links */}
          <div className="mt-10 pb-6 border-b border-white border-opacity-20">
            <div className="flex flex-wrap justify-center gap-4">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-3 bg-white bg-opacity-10 text-white hover:bg-white hover:text-[#bd1818] rounded-full transition-all duration-300 transform hover:scale-110"
                  aria-label={`Visit our ${link.name} page`}
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Copyright Section */}
          <div className="mt-6 text-center">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-300 mb-3 md:mb-0">
                &copy; {new Date().getFullYear()} Harsh Hasthkala | All Rights
                Reserved
              </p>
              <div className="flex items-center">
                <Image
                  src="/logo-R.png"
                  alt="Small Logo"
                  width={24}
                  height={24}
                  className="mr-2"
                />
                <p className="text-sm">
                  Harsh Hasthkala owned by harshhasthkala pvt limited
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
